import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CsvModule } from '@ctrl/ngx-csv';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExportCsvSelectionDialogComponent } from './export-csv-selection-dialog/export-csv-selection-dialog.component';
import { PipelineExportCSVComponent } from './pipeline-export-csv.component';
import { PipelineExportCsvService } from './pipeline-export-csv/pipeline-export-csv.service';
import { ExportCsvNotificationDialogComponent } from './export-csv-notification-dialog/export-csv-notification-dialog.component';

@NgModule({
  declarations: [ExportCsvNotificationDialogComponent, PipelineExportCSVComponent, ExportCsvSelectionDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    CsvModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    GalaxyWrapModule,
    MatCheckboxModule,
    GalaxyButtonLoadingIndicatorModule,
    ReactiveFormsModule,
  ],
  exports: [PipelineExportCSVComponent],
  providers: [PipelineExportCsvService],
})
export class PipelineCSVModule {}
